import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=fda924a6&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.STrKMrcDoQYq/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fda924a6')) {
      api.createRecord('fda924a6', component.options)
    } else {
      api.reload('fda924a6', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=fda924a6&", function () {
      api.rerender('fda924a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/Settings.vue"
export default component.exports